var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnectingArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.160156,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#4060EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3239 18.8925C22.3236 19.3529 22.6967 19.726 23.1572 19.7258C23.6176 19.7256 23.9911 19.3521 23.9913 18.8917L23.9945 13.0142C23.9947 12.5538 23.6216 12.1807 23.1612 12.1809L17.2572 12.1758C16.7967 12.1761 16.4233 12.5495 16.423 13.01C16.4228 13.4704 16.7959 13.8435 17.2564 13.8433L21.1476 13.8493L12.5536 22.4439C12.246 22.7515 12.2604 23.2647 12.5859 23.5902C12.9113 23.9156 13.4245 23.93 13.7322 23.6224L22.3261 15.0278L22.3239 18.8925Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectingArrow);
export default __webpack_public_path__ + "static/media/ConnectingArrow.06e892f822ce950ee28c19bc7d7d66c9.svg";
export { ForwardRef as ReactComponent };